import { render } from "./AccountSettings.vue?vue&type=template&id=db23f22e&scoped=true"
import script from "./AccountSettings.vue?vue&type=script&lang=js"
export * from "./AccountSettings.vue?vue&type=script&lang=js"

import "./AccountSettings.vue?vue&type=style&index=0&id=db23f22e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db23f22e"]])

export default __exports__